<template>
  <button
    :disabled="disabled"
    :class="{
      button: true,
      'button--small': size === 'small',
      'button--white': type === 'white',
    }"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    size: {
      type: String,
      defualt: "normal",
    },
    type: {
      type: String,
      default: "default",
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/Button.scss';
</style>
